/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class SmartAssistantProtectionStrService {
    get = this.i18nService.get;

    i18n = {
        helpTitle: this.get('protection.protect_simplifiedMode_configProtection_title'),
        helpText: this.get('protection.protect_simplifiedMode_configProtection_info'),
        lunLabel: this.get('common.LUNs'),
        fsLabel: this.get('common.fileSystem_title'),
        createProtection: this.get('protection.protect_simplifiedMode_configProtection_btn'),
        gifTip1: this.get('home.smartAssistant_protection_snapshotFigure1_info'),
        gifTip2: this.get('home.smartAssistant_protection_snapshotFigure2_info'),
    };
    /**
     * 数据保护动图下的文字内容
     */
    protectionGifTips = [this.i18n.gifTip1, this.i18n.gifTip2];

    constructor(private i18nService: I18nService) { }
}
